import wtApiClient from "./wtApiClient";
import ftApiClient from "./ftApiClient";

export const locationApi = {
    /**
     * FT-side single-call alternative to the cascading TDMS calls below.
     * Returns the full country -> state -> region -> locality tree
     * with TDMS-compatible integer IDs. Should be fetched once on app
     * bootstrap and cached in Redux. Some countries (e.g. Cambodia,
     * Costa Rica) skip the `states` level and have `regions` directly
     * under the country object.
     */
    getAllLocations: () => {
        const url = "/products/home/locations";
        return ftApiClient.get(url);
    },
    getCountries: () => {
        const url = "/categories/countries";
        return wtApiClient.get(url);
    },
    getStates: (countriesId: number | string) => {
        let url = "/categories/states";
        if (countriesId) {
            url += `?countries=${countriesId}`;
        }
        return wtApiClient.get(url);
    },
    getRegions: ({
        stateId,
        countryId,
    }: {
        stateId?: number | string;
        countryId?: number | string;
    }) => {
        let url = "/categories/regions";
        if (stateId) {
            url += `?states=${stateId}`;
        } else if (countryId) {
            url += `?countries=${countryId}`;
        }
        return wtApiClient.get(url);
    },

    getTowns: ({
        regionId,
        countryId,
    }: {
        regionId?: number | string;
        countryId?: number | string;
    }) => {
        let url = "/categories/locality";
        if (regionId) {
            url += `?regions=${regionId}`;
        } else {
            url += `?countries=${countryId}`;
        }
        return wtApiClient.get(url);
    },
};
